import {
  Badge,
  Box,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Table,
} from "@chakra-ui/react";

import { EventDetailPayoutsSectionData } from "@common/interfaces/KYDEvent";

export const PayoutsTable = ({
  data,
  ...props
}: {
  data: EventDetailPayoutsSectionData;
}) => {
  // Check if at least one payout has a rebate
  const hasRebate =
    data.journal_entries?.some(
      (entry) =>
        entry.rebate_amount &&
        entry.rebate_amount !== "-" &&
        entry.rebate_amount !== "0" &&
        entry.rebate_amount.trim() !== ""
    ) ?? false;

  return (
    <Table {...props}>
      <Thead>
        <Tr>
          <Th>Date</Th>
          <Th>Payout</Th>
          <Th>Hold</Th>
          {hasRebate && <Th>Rebate</Th>}
        </Tr>
      </Thead>
      <Tbody>
        {data.journal_entries &&
          data.journal_entries.map((payout) => (
            <Tr key={payout.financial_action_id}>
              <Td>
                <Text>{payout.created_at}</Text>
              </Td>
              <Td>
                <Text>{payout.payout_amount || "-"}</Text>
              </Td>
              <Td>
                <Text>{payout.hold_amount || "-"}</Text>
              </Td>
              {hasRebate && (
                <Td>
                  <Text>{payout.rebate_amount || "-"}</Text>
                </Td>
              )}
            </Tr>
          ))}
      </Tbody>
    </Table>
  );
};
